import React from 'react'
import PropTypes from 'prop-types'
import { SpecsContent } from './Specs.style'

const Specs = props => {
  const { attributes } = props
  if (!Array.isArray(attributes) || !attributes.length) return null

  return (
    <SpecsContent>
      <h2 id="product-specs">სპეციფიკაციები</h2>
      <ul>
        {attributes.map(spec => (
          <li key={spec.id}>
            <span>{spec.name}</span>
            <span>{spec.value}</span>
          </li>
        ))}
      </ul>
    </SpecsContent>
  )
}

Specs.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
}

export default Specs
